import mixpanel from 'mixpanel-browser';

export interface ViewProps {
  distinct_id?: string;
  [key: string]: any;
}

export const trackView = (eventName: string, props: ViewProps = {}) => {
  if (!eventName) {
    return;
  }

  // mixpanel.track exists on the default instance even before init, but calling it
  // without init throws when it reads this.config. Check config presence as the
  // real init signal, and wrap in try/catch so analytics can never break the app.
  const mp = mixpanel as unknown as { config?: object; track?: Function };
  if (!mp || !mp.config || typeof mp.track !== 'function') {
    return;
  }
  try {
    mp.track(eventName, {
      ...props,
      timestamp: new Date().toISOString(),
    });
  } catch (err) {
    // Telemetry must never break user-facing flows
    // eslint-disable-next-line no-console
    console.warn('trackView failed:', err);
  }
};
